/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_CategoriesInputs */

const en_admin_nav_categories = /** @type {(inputs: Admin_Nav_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories`)
};

/**
* | output |
* | --- |
* | "Categories" |
*
* @param {Admin_Nav_CategoriesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_categories = /** @type {((inputs?: Admin_Nav_CategoriesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_CategoriesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_categories(inputs)
});
export { admin_nav_categories as "admin.nav.categories" }